import { PaginationParams } from "../type";

export const COMMON_KEYS = {
  LOCATIONS: "locations",
  GET_LOCATIONS: (params?: PaginationParams) => [COMMON_KEYS.LOCATIONS, params],
  GET_COUNTRIES: () => ["countries"],
  GET_STAFF_ROLES: () => ["staff-roles"],
  GET_STAFF_ROLE_BY_NAME: (name: string, clientId?: string) => [
    "staff-role-by-name",
    name,
    clientId,
  ],
  GET_FILE_MIMETYPE: (fileUrl?: string) => ["file-mimetype", fileUrl],
  GET_INFINITE_LOCATIONS: (params?: PaginationParams) => [
    `${COMMON_KEYS.LOCATIONS}-infinite`,
    params,
  ],
};
